export const RouteGetMerchflowStorePog_storePogId_previousAssortment =
  "/merchflow/store/pog/:storePogId/previous-assortment";

export interface ParamsGetMerchflowStorePog_storePogId_previousAssortment {
  compare_with?: number;
}

export interface PreviousAssortmentProduct {
  product_code: string;
  name: string;
}

export interface ResponseGetMerchflowStorePog_storePogId_previousAssortment {
  source: "OWA" | "JDA" | "NONE";
  delivered_at: string | null;
  products: PreviousAssortmentProduct[];
}
